/* eslint-disable react-hooks/exhaustive-deps */
import {
  Button,
  Checkbox,
  Form,
  Grid,
  Input,
  Select,
  useForm,
} from "@pankod/refine-antd";
import { useCreate, useCustom } from "@pankod/refine-core";
import { useEffect } from "react";

import { BaseOptionType, DefaultOptionType } from "antd/es/select";
import { CREATE_BILL_RATE_API, RATE_TYPE_API } from "api/baseApi";
import { EAction, EStatusNotification, MSG_NOTIFICATION } from "constants/constant";
import { ICheckboxChangeActive } from "interfaces";
import { IService } from "interfaces/service";
import { IStandard } from "interfaces/standard";
import { openNotification } from "utils";
import "../../../../../styles/style.less";

type StandardBillRatesCreateProps = {
  isModalVisible: boolean;
  setIsModalVisible: (data: boolean) => void;
  customerId: string | null;
  page: number;
  handleChange: (page: number) => void;
};
const { Option } = Select;
export const StandardBillRatesCreate = (
  props: StandardBillRatesCreateProps
) => {
  const breakpoint = Grid.useBreakpoint();
  const isMobile = !breakpoint.md;
  const { setIsModalVisible, customerId, page, handleChange } = props;


  const { formProps, form } = useForm<IStandard>({
    action: EAction.CREATE,
  });

  const { data: servicesData } = useCustom({
    url: RATE_TYPE_API.getAll,
    method: "get",
    config: {
      query: {
        page: "",
        limit: "",
        search: "",
      },
    },
  });

  const onCheck = (event: ICheckboxChangeActive) => {
    if (event.target.checked) {
      form.setFieldsValue({ isActive: true });
    } else {
      form.setFieldsValue({ isActive: false });
    }
  };

  const { mutate, data: createData, isLoading } = useCreate();

  const onFinish = (event: IStandard) => {
    mutate(
      {
        resource: CREATE_BILL_RATE_API,
        values: {
          rateTypeId: event.rateTypeId,
          billRate: event.billRate,
          customerId: customerId,
          languageType: event.languageType,
          isActive: event.isActive,
        },
      },
      {
        onError: (error) => {
          
          openNotification(MSG_NOTIFICATION.ERROR, error.message, EStatusNotification.ERROR, 2);;
        },
      }
    );
  };

  useEffect(() => {
    if (createData?.data.status === 201) {
      form.resetFields();
      form.setFieldsValue({ languageType: "" });
      openNotification(MSG_NOTIFICATION.SUCCESSFUL, createData?.data?.message, EStatusNotification.SUCCESS);
      handleChange(page);
      setIsModalVisible(false);
    }
  }, [createData, form, setIsModalVisible]);

  return (
    <Form
      {...formProps}
      layout="vertical"
      onFinish={(event) => {
        onFinish(event as IStandard);
      }}
    >
      <Form.Item
        label="Type of Service"
        name="rateTypeId"
        rules={[
          {
            required: true,
            message: "Please enter Type of Service",
          },
        ]}
      >
        <Select
          showSearch
          style={{ width: "100%" }}
          optionFilterProp="children"
          filterOption={(
            input,
            option: BaseOptionType | DefaultOptionType | undefined
          ) => option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
          filterSort={(optionA, optionB) =>
            optionA.children
              .toLowerCase()
              .localeCompare(optionB.children.toLowerCase())
          }
        >
          {servicesData?.data?.results?.map((item: IService, index: number) => (
            <Select.Option key={index} value={item.id}>
              {item.name}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item
        label="Rate (per minute)"
        name="billRate"
        rules={[
          {
            required: true,
            pattern: /^-?\d*(\.\d*)?$/,
            message: "Please enter a valid number",
          },
        ]}
        normalize={(value, prevVal, prevVals) => value.trim()}
      >
        {/* <NumericInput value={billRate} onChange={(e) => setBillRate(e)} /> */}
        <Input maxLength={50} />
      </Form.Item>
      <Form.Item
        label="Language"
        name="languageType"
        rules={[
          {
            required: true,
            message: "Please enter language",
          },
        ]}
        initialValue={0}
      >
        <Select placeholder="language">
          <Option value={0}>All other languages</Option>
          <Option value={1}>American Sign Language</Option>
          <Option value={2}>Spanish</Option>
        </Select>
      </Form.Item>

      <Form.Item name="isActive" valuePropName="checked" initialValue={true}>
        <Checkbox
          onChange={(event) => {
            onCheck(event);
          }}
        >
          Is Active
        </Checkbox>
      </Form.Item>

      <div className={!isMobile ? "submit" : ""}>
        <Button type="primary" htmlType="submit" loading={isLoading}>
          Save
        </Button>
      </div>
    </Form>
  );
};
